/** Send field names once instead of repeating them for every stock row. */
export interface PackedRows<R extends object> {
  columns: (keyof R & string)[];
  values: R[keyof R][][];
}

export function packRows<R extends object>(rows: R[]): PackedRows<R> {
  const columns = rows.length
    ? (Object.keys(rows[0]) as (keyof R & string)[])
    : [];
  return { columns, values: rows.map((row) => columns.map((key) => row[key])) };
}

export function unpackRows<R extends object>({
  columns,
  values,
}: PackedRows<R>): R[] {
  return values.map(
    (row) => Object.fromEntries(columns.map((key, i) => [key, row[i]])) as R,
  );
}
